import React, { FC } from 'react'

import { Helmet } from 'react-helmet'
import { useIntl } from 'react-intl'

export const PageTitle: FC<{
  title: string
}> = ({ title }) => {
  const { locale } = useIntl()

  return (
    <Helmet>
      <html lang={locale} />
      <title>{title} | Swile</title>
    </Helmet>
  )
}
